module.exports = __webpack_public_path__ + "static/media/logo_header.5111a10d.svg";